import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.onna.winloses;

export const onnaWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
